import { ChangeDetectionStrategy, Component, inject, input, Input, OnInit, signal } from '@angular/core';
import {
  DayExpensesReleaseCalendar,
  ReleaseCalendarSelectedOptions
} from "../../types/release-calendar-types";
import {UtilityService} from "../../../../../core/services/utility.service";
import {ReleaseCalendarService} from "../../services/release-calendar.service";
import { days } from '../../configs/release-calendar-config';
import {smoothShowHideWidth} from "../../../../../shared/animations/smoothShowHideAnimations";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'app-release-calendar-team-expenses',
  standalone: true,
  imports: [
    MatButton
  ],
  templateUrl: './release-calendar-team-expenses.component.html',
  styleUrls: [
    './release-calendar-team-expenses.component.scss',
    '../release-calendar-components.styles.scss'
  ],
  animations: [ smoothShowHideWidth ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseCalendarTeamExpensesComponent implements OnInit {
  releaseCalendarTeamExpenses = input.required<Array<DayExpensesReleaseCalendar>>();
  releaseCalendarSelectedOptions = input.required<ReleaseCalendarSelectedOptions>();

  private utilityService:UtilityService = inject(UtilityService);
  private releaseCalendarService: ReleaseCalendarService = inject(ReleaseCalendarService);

  protected readonly days = days;
  public totalDays = signal<Array<number>>([]);
  public isVisible = signal<boolean>(false);
  public isLimitExceededForCurrentDay = signal<boolean>(false);

  public ngOnInit(): void {
    this.totalDays.set(this.releaseCalendarService.generateDays(this.releaseCalendarSelectedOptions()));
  }

  public formatBudgetValue(value: number): string {
    return this.utilityService.formatBudgetValue({ value });
  }

  public isSameDay(releaseCalendarAdvertisements: DayExpensesReleaseCalendar, dayLabel: number): boolean {
    const isLimitExceeded = this.releaseCalendarService.isLimitExceeded({
      price: releaseCalendarAdvertisements.price,
      plannedPrice: releaseCalendarAdvertisements.plannedPrice
    });
    this.isLimitExceededForCurrentDay.set(isLimitExceeded);
    return releaseCalendarAdvertisements.plannedDate['2'] === dayLabel;
  }

  public hasDataForDay(day: number): boolean {
    if (day === 0) return false;
    return this.releaseCalendarTeamExpenses().some(ad => this.isSameDay(ad, day));
  }

  public toggleVisibility(): void {
    this.isVisible.update(i => !i);
  }
}
